import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Button from 'components/inputs/Button';
import { dateTime } from 'helpers/sharedJsHelpers';

const { getTimeFromSeconds } = dateTime;

const PearsonEndQuizBlockModal = ({
  quiz, closeModal, goToNextQuizBlock
}) => {
  const secondsLeft = quiz.get('isBreakPooled') ? quiz.get('break_pool_seconds_remaining') : quiz.get('breakBlocksRemaining')?.first().get('seconds_remaining');
  const remainingBreaks = quiz.get('breakBlocksRemaining').size;

  const formatTime = (seconds) => {
    const hoursMinsSecs = getTimeFromSeconds(seconds);
    return `${hoursMinsSecs.hours} hours and ${hoursMinsSecs.minutes} minutes`;
  };

  useEffect(() => {
    if (quiz.get('breakBlocksRemaining').size === 0) {
      goToNextQuizBlock(quiz.get('currentQuizBlock').get('position') + 1);
      closeModal();
    }
  }, []);

  if (quiz.get('breakBlocksRemaining').size === 0) return null;

  return (
    <div className="bg-medium-persian-blue p-5">
      <div className="bg-light p-5">
        <div className="mb-5">
          <p>
            You may now take an optional break of up to {formatTime(secondsLeft)}. You have {formatTime(secondsLeft)} of TOTAL break time to use for this break AND total breaks remaining are {remainingBreaks}.
          </p>
          <p>
            Time spent on this break WILL NOT decrease your available exam time. If you do not take this break your exam will continue.
          </p>
          <p>
            If you want to take this break, click Yes.
          </p>
        </div>
        <div className="d-flex row justify-content-center">
          <Button styleVariant="none" className="bg-light shadow mr-3 px-5" onClick={() => goToNextQuizBlock(quiz.get('currentQuizBlock').get('position') + 1)}>Yes</Button>
          <Button styleVariant="none" className="bg-light shadow ml-3 px-5" onClick={() => goToNextQuizBlock(quiz.get('currentQuizBlock').get('position') + 2)}>No</Button>
        </div>
      </div>
    </div>
  );
};

PearsonEndQuizBlockModal.propTypes = {
  quiz: PropTypes.object.isRequired,
  closeModal: PropTypes.func,
  goToNextQuizBlock: PropTypes.func
};

export default PearsonEndQuizBlockModal;
